export const otherFeedbackIcon = {
  svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.25 5.25C15.92 5.25 16.52 5.58 16.88 6.09L21.25 12.25L16.88 18.41C16.52 18.92 15.92 19.25 15.25 19.25L4.25 19.24C3.15 19.24 2.25 18.35 2.25 17.25V7.25C2.25 6.15 3.15 5.26 4.25 5.26L15.25 5.25ZM4.25 17.25H15.25L18.8 12.25L15.25 7.25H4.25V17.25Z" fill="#6145CE"/>
    </svg>
    `,
  name: 'otherFeedback',
};
